/** @const {Array.<number>} cartTypes - 目前既有的購物車 type 編號 */
// 購物車類型 1-一般配送, 2-限神腦門市, 3-限宅配, 4-電子票券, 5-預購
export const cartTypes = [1, 2, 3, 4, 5];

/**
 * @const {Array.<number>} showShipFareCartTypes - 顯示運費的購物車 type 編號
 */
export const showShipFareCartTypes = [1, 2, 5];
